module.exports = __webpack_public_path__ + "static/media/leaf-icon.5bd3aede.svg";